// 1. Initialize Sentry FIRST
import { initSentry } from './utils/sentry';
initSentry();

import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { bundleMonitor } from './utils/bundle-monitor';
import { performanceMonitor } from './utils/performance';
import { ComprehensiveErrorBoundary } from './components/error/ComprehensiveErrorBoundary';

// 2. Initialize monitoring AFTER Sentry
bundleMonitor.init();
performanceMonitor.init();

// 3. Render the App inside comprehensive error boundary with network/CSS protection
createRoot(document.getElementById("root")!).render(
  <ComprehensiveErrorBoundary level="root" enableRetry showContactSupport>
    <App />
  </ComprehensiveErrorBoundary>
);
